import $ from "jquery";

require('./bootstrap');

/** JavaScript Library */
import flatpickr from "flatpickr";
import {Japanese} from "flatpickr/dist/l10n/ja"
import "flatpickr/dist/flatpickr.min.css"

/** Vue.js Library */
import Vue from 'vue';
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import VCalendar from 'v-calendar';


require('./Assets/listDeleteButton');
require('./Assets/mailInsertButton');
require('./Assets/mailModal');

Vue.use(VCalendar);
Vue.component("v-select", vSelect);
Vue.component(
    'mail-file-upload',
    require('./Components/MailTemplate/FileUpload').default
);
Vue.component(
    'faq-form',
    require('./Components/Faq/Form').default
);

$(function () {

    /**
     * 削除確認
     */
    $(".js_delete").click(function () {
        if (confirm("本当に削除しますか？")) {
        } else {
            return false;
        }
    });
    $(".js_delete_form").click(function () {
        if (confirm("本当に削除しますか？\n削除対象フォームの回答も削除されます。")) {
        } else {
            return false;
        }
    });

    /**
     * チェックボックス一括選択
     */
    const checkboxAll = document.querySelector(".js_checkbox_all");
    const checkboxList = document.querySelectorAll(".js_checkbox_list");
    if (checkboxAll) {
        checkboxAll.addEventListener('change', () => {
            if (checkboxAll.checked) {
                //全て選択
                for (let i in checkboxList) {
                    if (checkboxList.hasOwnProperty(i)) {
                        checkboxList[i].checked = true;
                    }
                }
            } else {
                //全て解除
                for (let i in checkboxList) {
                    if (checkboxList.hasOwnProperty(i)) {
                        checkboxList[i].checked = false;
                    }
                }
            }
        });
    }


    /**
     * 一括操作セレクトボックス制御
     */
    const bulk = document.querySelector(".js_bulk_confirm");

    if (bulk) {
        bulk.addEventListener("click", (e) => {
            const isCheck = Array.from(checkboxList).some(data => data.checked === true);
            const value = document.querySelector(".js_bulk").value;

            if (value === "init") {
                e.preventDefault();
                return false;
            }

            if (!isCheck || value === "" || value == null) {
                alert("項目を選択してください。")
                e.preventDefault();
                return false;
            }

            if (["delete_users", "delete_users"].indexOf(value) > -1) {
                if (confirm("選択項目を削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "delete_groups") {
                if (confirm("選択項目を削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "out_groups") {
                if (confirm("ユーザーをグループから削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "add_groups") {
                $("#modal").modal('show');
                const modal = document.getElementById('modal')
                const checkboxListModal = document.querySelectorAll(".js_checkbox_list_modal");

                //modal閉じる際のチェックボックスクリア
                modal.addEventListener('hidden.bs.modal', () => {
                    for (let i in checkboxListModal) {
                        if (checkboxListModal.hasOwnProperty(i)) {
                            checkboxListModal[i].checked = false;
                        }
                    }
                })
                e.preventDefault();
                return false;
            } else if (value === "mail_send") {
                e.preventDefault();

                // チェックされているIDを取得
                let values = $('.js_checkbox_list:checked').map((i, e) => {
                    return $(e).val();
                }).get();
                // モーダルにセット
                let $js_openMailModalInBulk = $('.js_openMailModalInBulk');
                let href = $js_openMailModalInBulk.attr('href');
                let replace = href.replace(/\/mail(\?.*?)?$/, '/mail?user_ids=' + values.join(','));
                $js_openMailModalInBulk.attr({'href': replace});
                $js_openMailModalInBulk.trigger('click');

                return false;
            } else if (value === "delete") {
                let $ids = $('.js-ids');
                let page = $ids.attr('data-page');
                if ($ids && page !== '') {
                    e.preventDefault();
                    let $form = $(e.target).parents('form');
                    let name = page + '_id[]';

                    // チェックされているIDを取得
                    let values = $('.js_checkbox_list:checked').map((i, e) => {
                        return $(e).val();
                    }).get();
                    $form.find("input[name='" + name + "']").remove();
                    $(values).each((i, v) => {
                        $ids.after(
                            $ids.clone()
                                .removeClass('js-ids')
                                .attr('name', name)
                                .val(v)
                        );
                    });
                    if (confirm('本当に削除しますか？')) {
                        $form.submit();
                    }
                    $form.find("input[name='" + name + "']").remove();
                }
            } else if (value === "delete_products") {
                if (confirm("選択項目を削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "delete_categories") {
                if (confirm("選択項目を削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "delete_forms") {
                if (confirm("選択項目を削除しますか？\n削除対象フォームの回答も削除されます。")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            } else if (value === "delete_form_logs") {
                if (confirm("選択項目を削除しますか")) {
                } else {
                    e.preventDefault();
                    return false;
                }
            }
        })
    }

    $('.js_select_multiple').select2({
        // dropdownAutoWidth: true,
        // width: "100px"
        width: 'resolve'
    });

    // bootstrapモーダル上でselect2を動作させる
    $('.js_select_multiple_in_modal').select2({
        dropdownParent: $('.js_bootstrap_modal'),
        width: '100%'
    });

    let $select2 = $('.js-select2');
    if ($select2) {
        $select2.each((i, el) => {
            let options = {
                dropdownAutoWidth: true,
                width: 'resolve',
                theme: "custom"
            };
            try {
                let opt = $(el).data('options');
                if (typeof opt === 'object') {
                    options = Object.assign(options, opt);
                }
            }catch(e){}
            $(el).select2(options);
        });
    }

    // DatePicker設定
    let $datepicker = $('.js-datepicker');
    if ($datepicker) {
        $datepicker.each((i, el) => {
            let options = {
                dateFormat: 'Y/m/d',
                locale: Japanese,
                wrap: true,
            };
            try {
                let opt = $(el).data('options');
                if (typeof opt === 'object') {
                    options = Object.assign(options, opt);
                }
            }catch(e){}
            flatpickr(el, options);
        });
    }

    const sideBarMinHeight = () => {
        $('#sidebarMenu').css({
            'min-height': $(window).height() - $('nav').outerHeight()
        });
    };
    sideBarMinHeight();

    $(window).on('resize', () => {
        sideBarMinHeight();
    });
})

/** Vue */
const app = new Vue({
    el: '#app',
    data() {
        return {
            errors: {}
        }
    }
});
